module.exports = __webpack_public_path__ + "static/logo-taspen-af993559bcf32b833066028216389cb3.png";